/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { getRequestOptions } from '../helpers/Fetchwrapper'
import { Table } from 'react-bootstrap-v5'
import { useParams, Link } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'

interface RouteParams {
	id: string;
}

function PackingOrderDetails() {
	const { id }: RouteParams = useParams()
	const [order, setOrder] = useState<any>(null)
	const [rows, setRows] = useState<any[]>([])
	const [materials, setMaterials] = useState<any[]>([])

	useEffect(() => {
		if (id) {
			fetch(process.env.REACT_APP_API_URL + 'packing-orders/' + id, getRequestOptions())
				.then((resp) => resp.json())
				.then((resp) => {
					setOrder(resp.data)
					setRows(resp.rows || [])
					setMaterials(resp.materials || [])
				})
				.catch((error) => console.log(error, 'catch the hoop'))
		}
	}, [id])

	if (!order) {
		return (
			<div className="card card-custom">
				<div className="card-body">Loading...</div>
			</div>
		)
	}

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Packing Order Details
					</span>
				</div>
				<div className="card-toolbar">
					<Link to="/packing-orders" className="btn btn-sm btn-secondary">Back</Link>
				</div>
			</div>
			<div className="card-body">
				<Table size="sm" bordered>
					<tbody>
						<tr>
							<td width="30%">Packing Order No</td>
							<td> : {order.packingOrderNo}</td>
						</tr>
						<tr>
							<td>Blending Order</td>
							<td> : {order.productionOrderNo}</td>
						</tr>
						<tr>
							<td>Project</td>
							<td> : {order.projectName}</td>
						</tr>
						<tr>
							<td>Packing Item Warehouse</td>
							<td> : {order.packingItemWarehouseName || order.warehouseName}</td>
						</tr>
						<tr>
							<td>Finished Good Warehouse</td>
							<td> : {order.finishedGoodsWarehouseName || order.warehouseName}</td>
						</tr>
						<tr>
							<td>Product</td>
							<td> : {order.itemName}</td>
						</tr>
						<tr>
							<td>Product Code</td>
							<td> : {order.itemCode}</td>
						</tr>
						<tr>
							<td>Production Quantity</td>
							<td> : {order.productionQuantity} {order.unitName}</td>
						</tr>
						<tr>
							<td>Packing Date</td>
							<td> : {order.packingDate}</td>
						</tr>
						<tr>
							<td>Created By</td>
							<td> : {order.createdBy}</td>
						</tr>
					</tbody>
				</Table>

				<h5 className="mt-5 mb-3">Pack Size</h5>
				<Table size="sm" bordered hover>
					<thead>
						<tr>
							<th>SN</th>
							<th>Packing</th>
							<th>Size</th>
							<th>Packing Unit</th>
							<th>BOM</th>
							<th>No of Packing</th>
							<th>Cost/Per Unit</th>
							<th>Total Cost</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => (
							<tr key={row.idPackingOrderRows || index}>
								<td>{index + 1}</td>
								<td>{row.packing}</td>
								<td>{row.size}</td>
								<td>{row.packingUnit}</td>
								<td>{row.bomName}</td>
								<td>{row.noOfPacking}</td>
								<td>{row.costPerUnit}</td>
								<td>{row.totalCost}</td>
							</tr>
						))}
					</tbody>
				</Table>

				<h5 className="mt-5 mb-3">Material to Use</h5>
				<Table size="sm" bordered hover>
					<thead>
						<tr>
							<th>Item</th>
							<th>Category</th>
							<th>Quantity</th>
							<th>Unit</th>
						</tr>
					</thead>
					<tbody>
						{materials.map((material, index) => (
							<tr key={material.idItems || index}>
								<td>{material.itemName}</td>
								<td>{material.categoryName}</td>
								<td>{parseFloat(Number(material.quantity).toFixed(5))}</td>
								<td>{material.unitName}</td>
							</tr>
						))}
					</tbody>
				</Table>
			</div>
		</div>
	)
}

export default PackingOrderDetails
